module.exports = __webpack_public_path__ + "static/media/techniqueClass.d7bc3deb.png";